import {
  prop,
  compose,
  split,
  find,
  propEq,
  toString,
  curry,
  chain,
  identity,
  length,
  lt,
  ifElse,
  always,
  isEmpty,
  reject
} from "ramda";
import { Maybe } from "ramda-fantasy";
import moment from "moment";
import IntlMessageFormat from "intl-messageformat";
import { NumberFormatOptions } from "i18n/helpers";

const splited = compose(Maybe.maybe(null, split(",")), Maybe.toMaybe);

const formatDate = (s, f = "DD.MM.YYYY") => moment(s).format(f);

const validatedDate = (s, f = "YYYY-MM-DD") =>
  moment(s).isValid() && formatDate(s, f);

const today = moment();
const tomorrow = moment().add(1, "day");
const yesterday = moment().subtract(1, "day");
const week = moment().subtract(6, "day");

const presets = [
  {
    id: 1,
    text: "Сегодня",
    start: today,
    end: today
  },
  {
    id: 2,
    text: "Вчера",
    start: yesterday,
    end: yesterday
  },
  {
    id: 3,
    text: "Неделя",
    start: week,
    end: today
  },
  {
    id: 4,
    text: "30 дней",
    start: moment()
      // .subtract(1, "month"),
      .subtract(29, "day"),
    end: today
  }
];

const getPreset = x => compose(Maybe.toMaybe, find(propEq("id", +x)))(presets);

const propToString = x => compose(toString, prop(x));
const getDate = (name, tab) =>
  compose(Maybe.maybe(0, propToString(name)), getPreset)(tab);

const safeProp = curry((x, obj) => Maybe.toMaybe(obj[x]));

const withDefaultDate = (defaultValue, key) =>
  compose(
    Maybe.maybe(defaultValue, identity),
    chain(safeProp(key)),
    safeProp("range")
  );

const tabs = [
  { title: "Сегодня", id: 1 },
  { title: "Вчера", id: 2 },
  { title: "Неделя", id: 3 },
  { title: "30 дней", id: 4 }
];

const tabIndex = presets.length + 1;

const chartOptions = {
  responsive: true,
  hoverMode: "index",
  stacked: false,
  title: {
    display: false,
    text: ""
  },
  animation: {
    duration: false
  },
  elements: {
    line: {
      tension: 0
    }
  },
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        type: "linear",
        display: true,
        position: "left",
        id: "cost",
        gridLines: {
          drawOnChartArea: false,
          color: "rgba(255,99,132,1)"
        }
      },
      {
        type: "linear",
        display: true,
        position: "right",
        id: "exposure",
        gridLines: {
          drawOnChartArea: false,
          color: "rgba(75, 192, 192, 1)"
        }
      },
      {
        type: "linear",
        display: true,
        position: "right",
        id: "cpm",
        gridLines: {
          drawOnChartArea: false,
          color: "rgba(153, 102, 255, 1)"
        }
      }
    ]
  }
};

const dateLengthCond = compose(lt(1), length, prop("date"));

const msg = new IntlMessageFormat("{name},{value, number, RUB}", "ru", {
  number: {
    RUB: {
      ...NumberFormatOptions,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  }
});

const formattedMessage = name =>
  msg
    .format({ name, value: 0 })
    .split("0")
    .join("");

const costLabel = formattedMessage("Доход");
const cpmLabel = formattedMessage("CPM");

const show = data => ({
  labels: data.date,
  datasets: [
    {
      yAxisID: "cost",
      label: costLabel,
      backgroundColor: "rgba(255, 99, 132, 0.2)",
      borderColor: "rgba(255,99,132,1)",
      fill: false,
      borderWidth: 1,
      data: data.cost
    },
    {
      yAxisID: "exposure",
      label: "Показы",
      backgroundColor: "rgba(75, 192, 192, 0.2)",
      borderColor: "rgba(75, 192, 192, 1)",
      borderWidth: 1,
      fill: false,
      data: data.exposure
    },
    {
      yAxisID: "cpm",
      label: cpmLabel,
      backgroundColor: "rgba(153, 102, 255, 0.2)",
      borderColor: "rgba(153, 102, 255, 1)",
      borderWidth: 1,
      fill: false,
      data: data.CPM
    }
  ]
});

const getChartData = ifElse(dateLengthCond, show, always(null));

const getFormats = compose(reject(isEmpty), split(","));

export {
  splited,
  validatedDate,
  formatDate,
  presets,
  today,
  tomorrow,
  yesterday,
  week,
  safeProp,
  withDefaultDate,
  tabs,
  getDate,
  tabIndex,
  chartOptions,
  getChartData,
  getFormats
};
